<template>
  <div>
    <div class="instruction_title text-left para-mrgn-20" v-translate:dynamic_string="{ key: `${translationKeyInitial}_formattedBody`, val: lang, html: question.formattedBody }" v-html="question.formattedBody" />
    <div @click.once="$emit('onClick', question)">
      <input v-model="question.answer" type="text" class="input-text readonly form-control" :disabled="isFieldDisabled" @input="onAnswerChange" @keydown="isNumber($event, componentData)" :class="{ 'is-danger': hasFieldError }" :placeholder="getPlaceHolderText(componentData)" />
      <div class="pt-5" v-if="componentData.hasUnits">{{ componentData.units }}</div>
    </div>
  </div>
</template>

<script>
import { Widget } from "@/components/services/participant-service";
import langTranslate from "./lang-translate";

export default {
  name: "number-response",
  mixins: [langTranslate],
  data() {
    return {
      hasFieldError: "",
      widget: new Widget()
    };
  },
  computed: {
    componentData() {
      return this.question.constraints;
    }
  },
  mounted() {
    this.$root.$on("questionSkipped", notifyObj => {
      if (!!notifyObj && notifyObj.identifier === this.question.identifier && notifyObj.skipped) {
        this.clearAnswer();
      }
    });
  },
  props: ["lang", "question", "isFieldDisabled", "isLegacyStudy"],
  methods: {
    getPlaceHolderText(componentData) {
      let placeholderText = this.widget.translate("rsb_hint_step_body_int_no_max", `Enter a number`);
      if (componentData && componentData.hasMinMax) {
        placeholderText += ` ${componentData.minValue}-${componentData.maxValue}`;
      }
      if (componentData && this.question && componentData.hasUnits && this.question.units) {
        placeholderText += this.getAnswerLabelUnits("units", this.question.units);
      }
      if (componentData && componentData.hasAnswerlabelunits && componentData.answerlabelunits) {
        placeholderText += this.getAnswerLabelUnits("answerlabelunits", componentData.answerlabelunits);
      }
      return `${placeholderText}`;
    },

    getAnswerLabelUnits(type, answer) {
      if (this.widget.i18nActivities(`${this.translationKeyInitial}_${type}`)) {
        return ` ${this.widget.i18nActivities(`${this.translationKeyInitial}_${type}`)}`;
      } else {
        return ` ${answer}`;
      }
    },

    isNumber(e, componentData) {
      if (componentData.allowDecimals && componentData.allowNegative) {
        if (isNaN(e.key) && e.key !== "." && e.key !== "-" && e.key !== "Backspace" && e.key !== "ArrowRight" && e.key !== "ArrowLeft") {
          e.preventDefault();
        }
        if (e.target.value.indexOf("-") >= 0 && e.key == "-") {
          e.preventDefault();
        } else if (e.target.value.indexOf(".") >= 0 && e.key == ".") {
          e.preventDefault();
        }
      } else if (componentData.allowDecimals) {
        if (isNaN(e.key) && e.key !== "." && e.key !== "Backspace" && e.key !== "ArrowRight" && e.key !== "ArrowLeft") {
          e.preventDefault();
        }
        if (e.target.value.indexOf(".") >= 0 && e.key == ".") {
          e.preventDefault();
        }
      } else if (componentData.allowNegative) {
        if (isNaN(e.key) && e.key !== "-" && e.key !== "Backspace" && e.key !== "ArrowRight" && e.key !== "ArrowLeft") {
          e.preventDefault();
        }
        if (e.target.value.indexOf("-") >= 0 && e.key == "-") {
          e.preventDefault();
        }
      } else if (isNaN(e.key) && e.key !== "Backspace" && e.key !== "ArrowRight" && e.key !== "ArrowLeft") {
        e.preventDefault();
      }
    },
    onAnswerChange() {
      this.$nextTick(() => {
        this.$emit("onAnswerChange", this.question);
      });
    },
    validateMinMaxErrors(answer, minValue, maxValue, hasSoftMinMax, softminValue, softmaxValue) {
      if (answer < minValue) {
        this.hasFieldError = true;
        this.fieldErrorText = `Answer should have a min of ${minValue}`;
        if (hasSoftMinMax) {
          if (answer > softminValue) {
            this.hasFieldError = false;
            this.hasFieldWarning = true;
            this.fieldErrorText = "";
            this.fieldWarningText = `This value is less than min (${minValue}) but greater than soft min (${softminValue})`;
            return false;
          }
        }
        return true;
      }
      if (answer > maxValue) {
        this.hasFieldError = true;
        this.fieldErrorText = `Answer should have a max of ${maxValue}`;
        if (answer < softmaxValue) {
          this.hasFieldError = false;
          this.hasFieldWarning = true;
          this.fieldErrorText = "";
          this.fieldWarningText = `This value is greater than max (${maxValue}) but less than soft max (${softmaxValue})`;
        }
        return true;
      }
      return false;
    },
    validateAllowDecimals(answer, allowDecimals) {
      if (allowDecimals) {
        return false;
      }
      if (!allowDecimals && !Number.isInteger(answer)) {
        this.hasFieldError = true;
        this.fieldErrorText = `Decimals not allowed`;
        return true;
      }
    },
    validateAllowNegativeValues(answer, allowNegative) {
      if (allowNegative) {
        return false;
      }
      if (answer < 0) {
        this.hasFieldError = true;
        this.fieldErrorText = `Negative value not allowed`;
        return true;
      }
    },
    validateIsValidNumber(answer) {
      if (isNaN(Number(answer))) {
        this.hasFieldError = true;
        this.fieldErrorText = `Answer should be a valid number`;
        return true;
      }
      return false;
    },
    validateIsRequired(answer) {
      if (answer === "" || answer == undefined) {
        this.hasFieldError = true;
        this.fieldErrorText = `Answer is required. Please fill`;
        return true;
      }
      return false;
    },
    checkForFieldErrors() {
      let { answer, minValue, maxValue, hasMinMax, hasSoftMinMax, allowDecimals, allowNegative, softminValue, softmaxValue, isSkippable } = this.question;
      this.resetAllErrors();

      if (isSkippable && (answer == "" || answer == undefined)) {
        return;
      }
      if (this.validateIsValidNumber(answer)) {
        return;
      }

      answer = Number(answer);
      if (hasMinMax) {
        if (this.validateMinMaxErrors(answer, minValue, maxValue, hasSoftMinMax, softminValue, softmaxValue)) {
          return;
        }
      }

      if (this.validateAllowDecimals(answer, allowDecimals)) {
        return;
      }
      if (this.validateAllowNegativeValues(answer, allowNegative)) {
        return;
      }

      this.hasFieldError = false;
    },
    clearAnswer() {
      this.question.answer = undefined;
      this.componentData.computedScore = 0;
      this.componentData.actualScore = 0;
    }
  }
};
</script>
